<template>
  <div>
    <vl-map
      ref="map"
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
    >
      <!-- vl-view is the component to act upon to change the center, resolution and rotation of the map -->
      <vl-view
        ref="mapView"
        :zoom.sync="zoomMap"
        :center.sync="center"
        :rotation.sync="rotation"
        max-zoom="18"
      ></vl-view>

      <!-- Can render images from sources that provide pre-rendered -->
      <vl-layer-tile id="osm">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>

      <vl-layer-vector>
        <vl-source-vector ref="vectorSource">
          <!-- Iteracion por cada punto dle mapa -->
          <vl-feature
            v-for="(data, index) in nodesCoordinatesList"
            :key="index"
          >
            <!-- Punto geometrico -->
            <vl-geom-point
              :coordinates="[data.latitud, data.longitud]"
            ></vl-geom-point>
            <!-- Titulo popup-->
            <vl-overlay :position="[data.latitud, data.longitud]">
              <template>
                <div class="overlay-content">{{ data.alias }}</div>
              </template>
            </vl-overlay>
          </vl-feature>

          <!-- Imagen del punto -->
          <vl-style-box>
            <vl-style-icon
              src="https://img.icons8.com/office/50/000000/place-marker.png"
              :anchor="[0.5, 1]"
            ></vl-style-icon>
          </vl-style-box>
        </vl-source-vector>
      </vl-layer-vector>
    </vl-map>
  </div>
</template>

<script>
//https://vuelayers.github.io/#/docs/component/overlay
export default {
  name: "VueLayers",
  data() {
    return {
      zoomMap: this.zoom,
      maxZoom: 14, // visible at zoom levels 14 and below
      rotation: 0,
      geolocPosition: undefined,
      mapCursor: "default",
    };
  },
  props: {
    latitude: Number,
    longitude: Number,
    zoom: Number,
    nodesCoordinates: Array,
  },
  computed: {
    nodesCoordinatesList: {
      get: function () {
        return this.nodesCoordinates;
      },
      set: function (/*newValue*/) {
        //this.nodesCoordinates = newValue;
      },
    },
    center: {
      get: function () {
        if (this.nodesCoordinatesList && this.nodesCoordinatesList[0]) {
          return [
            this.nodesCoordinates[0].latitud,
            this.nodesCoordinates[0].longitud,
          ];
        } else {
          return [this.longitude, this.latitude];
        }
      },
      set: function (/*newValue*/) {
        //this.longitude = newValue[0];
        //this.latitude = newValue[1];
      },
    },
  },
  methods: {
    onMapPointerMove({ pixel }) {
      let hit = this.$refs.map.forEachFeatureAtPixel(pixel, () => true);
      if (hit) {
        this.mapCursor = "pointer";
      } else {
        this.mapCursor = "default";
      }
    },
  },

  mounted () {
  	setTimeout(() => {
      try{
        this.$refs.mapView.$view.fit(this.$refs.vectorSource.$source.getExtent(), {
          size: this.$refs.map.$map.getSize(),
          duration: 1000,
        })
      }catch (e) {
        console.log(e);
      }
    }, 1000)
  },
};
</script>

<style scoped>
.overlay-content {
  position: relative;
  display: block;
  background-color: white;
  box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
  padding: 15px;
  border-radius: 10px;
  border: 1 px solid #cccccc;
  bottom: 12 px;
  left: -50 px;
  min-width: 380 px;
}
</style>